import { useEffect, useState } from "react";
import { getLogin, getLoginWithToken, removeCookie, setCookie, updateJobs } from "../scripts/xhrf";


export default function LoginApp(){

  useEffect(()=>{
    document.title = "CC Login"
  });

  return(
    <LoginWindow/>
  );
}

function LoginWindow(){
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const [statusmsg,setStatusmsg] = useState("");

  // Falls ein Token vorhanden ist im Query so wird automatisch ein Loginversuch unternommen
  let t = new URLSearchParams(window.location.search).get("token");
  if(t!==null){
    loginOrSo(false,t);
  }

  // bool withCredentials -> Falls mit user/pass eingeloggt wird
  async function loginOrSo(withCredentials,token=0){
    let answer;
    if(withCredentials){
      answer = await getLogin(username,password);
    }else{
      answer = await getLoginWithToken(token);
    }
    if(answer.data.auth === null){
      if(answer.errors[0].code === 500){
        setStatusmsg("Username oder Passwort falsch")
      }else{
        alert("Error Code: " + answer.errors[0].code + ": " + answer.errors[0].message);
      }
      return;
    }

    // tk beinhaltet den Token aus der answer des Servers
    let tk;
    if(withCredentials){
      tk = answer.data.auth.login.authToken;
    }else{
      tk = answer.data.auth.loginWithToken.authToken;
    }

    // Token wird als Cookie gespeichert. Mithilfe des JWT-Tokens kann ermittelt werden ob es ein interner Mitarbeiter ist.
    // Falls ja wird ebenfalls ein Cookie dafür gesetzt.
    setCookie("token",tk);
    if(JSON.parse(window.atob(tk.split('.')[1])).isInternal){
      setCookie("internal","X");
    }else{
      removeCookie("internal");
    }

    // Für die Startseite wird zunächst ein Jobpolling ausgeführt um direkt ausstehende Jobs anzeigen zu können.
    await updateJobs();
    // Sollte ein Direktlink zu einem Medienobjekt aus dem alten Content Rating Tool verwendet werden, so steht in Target das gewünschte Zielobjekt
    // Andernfalls wird auf die Startseite geleitet
    let s = new URLSearchParams(window.location.search).get("target");
    if(s!==null){
      window.location.href = s;
    }else{
      window.location.href = "/home";
    }
  }

  return(
    <div className="bg-white rounded-lg mx-auto my-10 grid place-items-center w-[400px] h-[300px]">
      <h1 className="text-3xl font-bold">
        ContentControl Login
      </h1>
      <input className="bg-transparent border-b-2 outline-none" type="text" placeholder="Username" onInput={(e)=>setUsername(e.target.value)} value={username}></input>
      <input className="bg-transparent border-b-2 outline-none" type="password" placeholder="Password" onInput={(e)=>setPassword(e.target.value)} value={password}></input>
      <button className="bg-blue-500 hover:bg-blue-800 text-white rounded-lg px-3 w-24 h-10 text-xl font-bold" onClick={()=>loginOrSo(true)}>
        Login
      </button>
      <p className="text-red-700">{statusmsg}</p>
    </div>
  );
}